import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'overview-item-five',
  templateUrl: './item-one.component.html',
  styles: ['.item-one { padding: 10px; background-color: lightblue; }']
})
export class ItemFiveComponent implements OnInit {
	@Input() job: any;
	constructor() {
		
	}
	ngOnInit() {
	}
}